import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import { KeyValue } from "@/main/models/common";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from "@/main/services/utils";
import { getValuators, resetReducerValuators, useValuatorReducer } from "@/main/store/valuator";
import { useDinamicFiltersMappingCodes } from "./dinamicFiltersMappingCodes";

export const INITIAL_FORM_STATE_VALUATOR = {
	valuator: null as KeyValue | null,
};

export type IFormFiltersMappingTypeValuator = typeof INITIAL_FORM_STATE_VALUATOR;

interface IFiltersMappingTypeValuatorProps {}
function FiltersMappingTypeValuator(_props: IFiltersMappingTypeValuatorProps) {
	const dispatch = useDispatch();
	const { watcherCountry, isRequiredField } = useDinamicFiltersMappingCodes();
	const { valuators: valuatorsReducer } = useValuatorReducer();

	const { control, resetField, setValue } = useFormContext<IFormFiltersMappingTypeValuator>();

	useEffect(() => {
		if (!isValueQueryParams(watcherCountry)) {
			resetField("valuator");
		}
		if (isNullUndefined(watcherCountry)) return;

		dispatch(
			getValuators({
				guidCountry: String(watcherCountry?.key),
				idStatusRegister: StatusRegisterEnum.Active,
			}),
		);

		return () => {
			dispatch(resetReducerValuators());
		};
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledValuator = isNullUndefined(valuatorsReducer.data) || valuatorsReducer.data.length === 1;

	return (
		<KogAutoCompleteControlled
			id="id-mappingCode-select-valuator"
			nameCustom="valuator"
			label={getTranslateByKey("information.valuator")}
			isDefaultValueUnique
			control={control}
			setValueCustom={setValue}
			options={valuatorsReducer.data}
			isLoading={valuatorsReducer.isLoading}
			disabled={disabledValuator}
			rulesCustom={{ required: isRequiredField("valuator") }}
			onChangeCustom={() => {}}
		/>
	);
}

export default FiltersMappingTypeValuator;
